module.exports = __webpack_public_path__ + "img/emergencyDisposal_checked.0cdd847d.png";